import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Building2, Instagram, Facebook, Video, Youtube, Twitter, Mail, Phone, ExternalLink, Compass, Globe, Home as HomeIcon, Share2, Bell, ShieldCheck } from 'lucide-react';
const profiles = [{
  title: 'Compass',
  icon: Compass,
  url: '#'
}, {
  title: 'Website',
  icon: Globe,
  url: '#'
}, {
  title: 'Realtor.com',
  icon: HomeIcon,
  url: '#'
}];
export function ProfileHeroLinkedIn() {
  const handleShare = async () => {
    if (navigator.share) {
      await navigator.share({
        title: 'Marcus Chen — Eaves Pro Profile',
        text: "See Marcus Chen's verified performance data on Eaves",
        url: window.location.href
      });
    } else {
      await navigator.clipboard.writeText(window.location.href);
      alert('Link copied to clipboard!');
    }
  };
  return <section className="bg-brand-offwhite pb-12" data-id="element-323">
      {/* Banner */}
      <div className="h-48 md:h-64 bg-gradient-to-r from-brand-sage via-brand-sandstoneBg to-brand-light relative" data-id="element-324">
        <div className="absolute inset-0 opacity-20 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-brand-forest to-transparent" data-id="element-325"></div>

        {/* Top bar */}
        <div className="max-w-6xl mx-auto px-6 md:px-12 pt-6 flex items-center justify-between relative z-10" data-id="element-326">
          <a href="/" className="inline-flex items-center gap-2 px-3 py-1.5 bg-white/60 backdrop-blur-md border border-white/40 hover:bg-white/80 rounded-full transition-colors shadow-sm" data-id="element-327">
            <img src="https://cdn.magicpatterns.com/uploads/tg3VtfRMGFLgjFkX7oevaV/eaves_favicon_transparent.png" alt="Eaves" className="h-5 w-5 brightness-0 opacity-80" data-id="element-328" />
            <span className="hidden sm:inline text-sm text-brand-dark font-serif font-medium tracking-wide" data-id="element-329">
              Eaves
            </span>
          </a>
          <div className="flex items-center gap-2" data-id="element-330">
            <button onClick={handleShare} className="inline-flex items-center gap-1.5 px-3 py-1.5 text-sm text-brand-dark bg-white/60 backdrop-blur-md border border-white/40 hover:bg-white/80 rounded-full transition-colors shadow-sm" data-id="element-331">
              <Share2 size={15} data-id="element-332" />
              <span className="hidden sm:inline" data-id="element-333">Share</span>
            </button>
            <button className="inline-flex items-center gap-1.5 px-3 py-1.5 text-sm text-white bg-brand-forest hover:bg-brand-forestHover rounded-full transition-colors shadow-sm" data-id="element-334">
              <Bell size={15} data-id="element-335" />
              <span className="hidden sm:inline" data-id="element-336">Subscribe</span>
            </button>
          </div>
        </div>
      </div>

      {/* Main Card */}
      <div className="max-w-5xl mx-auto px-4 md:px-8 -mt-16 md:-mt-24 relative z-20" data-id="element-337">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="bg-white rounded-2xl shadow-premium border border-brand-light p-6 md:p-8" data-id="element-338">
          <div className="flex flex-col md:flex-row gap-6 md:gap-8" data-id="element-339">
            {/* Left Column: Photo & Badge */}
            <div className="flex flex-col items-center md:items-start shrink-0" data-id="element-340">
              <div className="w-32 h-32 md:w-40 md:h-40 rounded-full overflow-hidden border-4 border-white shadow-md bg-white -mt-16 md:-mt-20 relative z-10" data-id="element-341">
                <img src="https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400&h=400&fit=crop" alt="Marcus Chen" className="w-full h-full object-cover" data-id="element-342" />
              </div>
            </div>

            {/* Right Column: Info */}
            <div className="flex-1 text-center md:text-left pt-2 md:pt-0" data-id="element-343">
              <div className="flex flex-col md:flex-row md:items-start justify-between gap-4 mb-4" data-id="element-344">
                <div data-id="element-345">
                  <h1 className="text-3xl md:text-4xl font-serif font-semibold mb-1 text-brand-dark" data-id="element-346">
                    Marcus Chen
                  </h1>
                  <h2 className="text-lg text-brand-muted font-serif italic mb-3" data-id="element-347">
                    Senior real estate advisor
                  </h2>
                  <div className="inline-flex items-center gap-1.5 bg-brand-sage/50 border border-brand-sage text-brand-forest px-3 py-1 rounded-full text-xs font-medium tracking-wide mb-4" data-id="element-348">
                    <Building2 size={14} data-id="element-349" />
                    <span data-id="element-350">Compass Real Estate · The Chen Group</span>
                  </div>
                  <div className="flex flex-wrap items-center justify-center md:justify-start gap-3 text-sm text-brand-muted" data-id="element-351">
                    <span className="flex items-center gap-1.5" data-id="element-352">
                      <MapPin size={14} className="text-brand-forest" data-id="element-353" />
                      San Francisco Bay Area
                    </span>
                    <span className="hidden sm:inline text-brand-light" data-id="element-354">|</span>
                    <span className="flex items-center gap-1.5" data-id="element-355">
                      <ShieldCheck size={14} className="text-brand-forest" data-id="element-356" />
                      DRE #02145678 · Verified
                    </span>
                  </div>
                </div>

                {/* Social Actions */}
                <div className="flex flex-wrap items-center justify-center md:justify-end gap-2" data-id="element-357">
                  {[Instagram, Facebook, Video, Youtube, Twitter].map((Icon, i) => <a key={i} href="#" className="w-9 h-9 rounded-full bg-brand-offwhite hover:bg-brand-sage text-brand-muted hover:text-brand-forest flex items-center justify-center transition-colors" data-id="element-358">
                        <Icon size={16} data-id="element-359" />
                      </a>)}
                  <span className="w-px h-5 bg-brand-light mx-1" data-id="element-360"></span>
                  <a href="mailto:marcus@chengroup.com" className="w-9 h-9 rounded-full bg-brand-offwhite hover:bg-brand-sage text-brand-muted hover:text-brand-forest flex items-center justify-center transition-colors" data-id="element-361">
                    <Mail size={16} data-id="element-362" />
                  </a>
                  <a href="tel:+14155550198" className="w-9 h-9 rounded-full bg-brand-offwhite hover:bg-brand-sage text-brand-muted hover:text-brand-forest flex items-center justify-center transition-colors" data-id="element-363">
                    <Phone size={16} data-id="element-364" />
                  </a>
                </div>
              </div>

              {/* Profiles Row */}
              <div className="flex flex-wrap items-center justify-center md:justify-start gap-2 mb-8" data-id="element-365">
                {profiles.map(p => {
                const Icon = p.icon;
                return <a key={p.title} href={p.url} className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md bg-brand-offwhite hover:bg-brand-sage text-sm text-brand-dark transition-colors border border-brand-light" data-id="element-366">
                      <Icon size={14} className="text-brand-muted" data-id="element-367" />
                      <span className="font-medium" data-id="element-368">{p.title}</span>
                      <ExternalLink size={12} className="text-brand-muted opacity-50" data-id="element-369" />
                    </a>;
              })}
              </div>

              {/* Credentials Row */}
              <div className="grid grid-cols-2 gap-4 pt-6 border-t border-brand-light" data-id="element-370">
                <div className="text-center md:text-left" data-id="element-371">
                  <p className="text-xl font-mono text-brand-dark font-semibold mb-1" data-id="element-372">
                    14 years
                  </p>
                  <p className="text-xs text-brand-muted" data-id="element-373">Experience</p>
                </div>
                <div className="text-center md:text-left" data-id="element-374">
                  <p className="text-xl font-mono text-brand-dark font-semibold mb-1" data-id="element-375">
                    Top 13%
                  </p>
                  <p className="text-xs text-brand-muted" data-id="element-376">In 94109</p>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}